const CALENDLY_URL = 'https://paystack.com/buy/private-clarity-call-sdonrr';

export default function AboutCtaSection() {
  return (
    <section className="bg-[#6B1E3B] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-3xl mx-auto text-center">
        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#FDFAF8] mb-6 leading-tight">
          Ready to experience it for yourself?
        </h2>

        {/* Body */}
        <p className="font-body text-sm md:text-base text-[#E8E8E8] mb-10">
          A clarity call is where it begins. 30 minutes. Just a conversation.
        </p>

        {/* CTA Button */}
        <a
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-8 py-4 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300 w-full sm:w-auto"
        >
  Book Your Clarity Call
</a>
<p className="text-xs text-[#E8E8E8] text-center mt-2">
  <a href="https://paystack.com/buy/private-clarity-call-sdonrr" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#C9A84C]">Book a Private Clarity Call</a>
</p>
      </div>
    </section>
  );
}